import { useNavigate } from "react-router-dom";
import { BriefcaseFill } from "react-bootstrap-icons";
import { optionsArray } from "../helpers/hardCodedData";
import { sortedStrings } from "../helpers/stringHelpers";
import Avatar from "./reusable/Avatar";

const CustomerHero = ({
  userName,
  userImage,
  businessName,
  category,
  followers,
  following,
}) => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column gap-3">
      {/* Profile Card */}
      <div className="profile-card">
        <div className="profile-card-cover" />
        <div className="profile-card-avatar">
          <Avatar src={userImage} alt={businessName} size="xl" />
        </div>
        <div className="profile-card-body">
          <div className="profile-card-name">{businessName}</div>
          <div className="profile-card-category">
            <BriefcaseFill style={{ marginRight: "4px", fontSize: "12px" }} />
            {category ?? "Not assigned yet"}
          </div>

          <div className="profile-card-stats">
            <div
              className="profile-stat"
              onClick={() =>
                navigate("/account-follow", { state: "followers" })
              }
            >
              <span className="profile-stat-value">{followers}</span>
              <span className="profile-stat-label">Followers</span>
            </div>
            <div
              className="profile-stat"
              onClick={() =>
                navigate("/account-follow", { state: "following" })
              }
            >
              <span className="profile-stat-value">{following}</span>
              <span className="profile-stat-label">Following</span>
            </div>
          </div>
        </div>
      </div>

      {/* Categories Quick Nav */}
      <div className="sidebar-card">
        <div className="sidebar-card-header" style={{ fontSize: "15px" }}>
          Categories
        </div>
        <div className="sidebar-card-body">
          {sortedStrings(optionsArray)?.map((item, i) => (
            <button
              key={i}
              className="sidebar-item w-100 border-0"
              style={{ fontSize: "13px", background: "transparent" }}
              onClick={() => navigate("/view-categories", { state: item })}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerHero;
